import { SVGProps } from 'react'

import { CheetahIconPack } from './enum'
import * as Icons from './svgs'

export { CheetahIconPack }
export interface Props extends SVGProps<SVGSVGElement> {
  name: CheetahIconPack
}

const CheetahIcon = ({ name, ...svgProps }: Props): JSX.Element | null => {
  // eslint-disable-next-line import/namespace
  const SVGICon = Icons[name]

  if (!SVGICon) {
    return null
  }

  return <SVGICon {...svgProps} />
}

export default CheetahIcon
